<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            <span v-if="filiation.id">Редактирование филиала</span>
                            <span v-else>Добавление филиала</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Наименование</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.filiation.name.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.filiation.name.$error === true || forms.filiation.errors.name" class="error">
                                        {{ this.forms.filiation.errors.name ? this.forms.filiation.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                            <div class="section row mb25">
                                <div class="col-md-12">
                                    <label class="field-label">Адрес</label>
                                    <label class="field prepend-icon">
                                        <textarea class="gui-textarea" v-model="$v.filiation.address.$model"></textarea>
                                        <label class="field-icon">
                                            <i class="fa fa-edit"></i>
                                        </label>
                                    </label>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.filiation.isSubmitting">
                                <span v-if="filiation.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Filiation from "../../models/Filliation";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            if (to.params.id) {
                try {
                    const filiation = await Filiation.get(to.params.id);
                    next(component => {
                        component.filiation = filiation;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                });
            }
        },
        data() {
            return {
                filiation: new Filiation(),
                forms: {
                    filiation: {
                        isSubmitting: false,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            filiation: {
                name: {required},
                address: {},
            },
        },
        methods: {
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.filiation.isSubmitting = true;
                this.forms.filiation.errors = {};

                if (this.filiation.id) {

                    try {
                        await this.filiation.update();
                    } catch (error) {
                        this.forms.filiation.errors = error.errors;
                    }

                } else {

                    try {
                        await this.filiation.add();

                        await this.$router.push({name: 'filiation-edit', params: {id: this.filiation.id}});
                    } catch (error) {
                        this.forms.filiation.errors = error.errors;
                    }

                }

                this.forms.filiation.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Филиал - ' + (this.forms.filiation.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>